export const API_SEND_MAIL = 'https://us-central1-vfa-sound-product-dev.cloudfunctions.net/sendContact';
